import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJCommonModal from "../../../common/component/modal/FJCommonModal";
import FJQuickGuideModal from "../view/FJQuickGuideModal";
import {FJModalAction} from "../../../redux/action/FJRoot.action";
import FJUtil from "../../../util/FJUtil";

class FJQuickGuideModalContainer extends Component {

  _startTime = 0;
  _step = 0;

  _onCancel = () => {
    let isShowQuickGuide = localStorage.getItem('isShowQuickGuide');
    FJUtil.ealog('timeline_welcome panel close', {
      time: (Date.now() - this._startTime) / 1000,
      step: this._step + 1,
      "whether to check don't show agian": isShowQuickGuide === 'false'
    });
    this.props.onCancel();
  };

  /**
   * @description 设置播放进度
   * @private
   */
  _setStep = (index) => {
    if (index >= this._step) {
      this._step = index
    }
  };

  render() {
    let {
      visible
    } = this.props;
    return (
      <FJCommonModal visible={visible}
                     hasOuterCloseBtn
                     onCancel={this._onCancel}
                     render={(shown) => {
                       return shown && <FJQuickGuideModal shown={shown}
                                                          onCancel={this._onCancel}
                                                          setStep={this._setStep}/>
                     }}
      />
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.modal.isShowQuickGuideModal
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    onCancel: function () {
      dispatch(FJModalAction.setIsShowQuickGuideModalAction(false));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJQuickGuideModalContainer);
